"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaObject = void 0;
var _drywall = require("drywall");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _MediaObjectMixin = require("../../mixins/components/MediaObjectMixin");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
/**
 * @since 7.6.0
 */
var MediaObject = /*#__PURE__*/(0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_drywall.MediaObject, props);
}).withConfig({
  displayName: "MediaObject",
  componentId: "c11n-8-107-0__sc-1c6i1ap-0"
})(["", ""], _MediaObjectMixin.MediaObjectMixin);
exports.MediaObject = MediaObject;
MediaObject.displayName = 'MediaObject';
MediaObject.propTypes = {
  /**
   * How to align the media content with respect to the children content.
   */
  align: _propTypes.default.oneOf(['start', 'top', 'center', 'bottom', 'end']),
  /**
   * The body content.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The direction in which the media and content will be placed.
   */
  direction: _propTypes.default.oneOf(['column', 'row']),
  /**
   * The spacing value between media and children content.
   */
  gutter: _customPropTypes.default.spacing,
  /**
   * The media content.
   */
  media: _propTypes.default.node.isRequired,
  /**
   * You can use `renderLayout` to modify the default composition of the component.
   * Pass your own node using the `<MediaObject.Body>` and `<MediaObject.Media>` wrappers,
   * or pass a render function that receives enhanced props as the only argument.
   */
  renderLayout: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * By default, the media will come before the body.
   * Set this to reverse the order of media and body.
   */
  reverse: _propTypes.default.bool
};
MediaObject.defaultProps = {
  direction: 'row',
  gutter: 'sm'
};
MediaObject.Body = _drywall.MediaObject.Body;
MediaObject.Media = _drywall.MediaObject.Media;

/** @component */